import { actionCreator } from '@ardoq/rxbeach';
import { viewSettingsConsts } from './consts';

type PayloadViewSettings = {
  readonly viewId: string;
  readonly settings: Record<string, any> & {
    [viewSettingsConsts.FULLSCREEN_KEY]?: boolean;
  };
  readonly persistent: boolean;
  readonly settingsPath?: string[];
};

// TODO: mark this as deprecated upon completion
export const updateViewSettings = actionCreator<PayloadViewSettings>(
  '[viewSettingsActions] UPDATE_VIEW_SETTINGS'
);
